<template>
  <div class="text-center notifications">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon v-if="notifications.length > 0" color="red">mdi-message-alert</v-icon>
          <v-icon v-else>mdi-message-alert</v-icon>
        </v-btn>
      </template>
      <v-list max-height="400" v-if="notifications.length > 0" two-line>
        <v-list-item-group
          v-model="selected"
          active-class="pink--text"
        >
          <template v-for="(notification, index) in notifications">
          <a :key="notification.id" :href="`/lead/${notification.lead_id}`">
            <v-list-item class="notifications__item">
              <template>
                <v-list-item-content>
                  <v-list-item-title v-text="notification.type === 'message' ? `Message from ${notification.lead_name}` : `Voicemail from ${notification.lead_name}` "></v-list-item-title>
                  <v-list-item-subtitle v-text="notification.body.length > 47 ? notification.body.substring(0, 47) + '...' : notification.body"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text v-text="notification.time_passed"></v-list-item-action-text>
                  <v-list-item-action-text v-text="''"></v-list-item-action-text>
                </v-list-item-action>
              </template>
            </v-list-item>
          </a>
          <v-divider
            v-if="index < notifications.length - 1"
            :key="index"
          ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
      <v-list v-else>
        <v-list-item>
          No notifications
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "NotificationsList",
  props: {
    notifications: Array,
  },
  data() {
    return {
      selected: [0],
    }
  },
}
</script>

<style lang="scss">
  a {
    text-decoration: none !important;
    color: #000 !important;
  }
  .notifications {
    &__item {
      max-width: 400px;
      background-color: #fff;
    }
  }
  .v-item-group {
    background-color: #fff;
  }
</style>